<template>
  <form @submit.prevent="update" class="flex flex-col">
    <div class="flex-grow p-6">
      <div
        v-if="notFound"
        class="flex flex-col items-center justify-center py-20 text-center"
      >
        <span class="text-5xl text-gray-300 material-icons-round">translate</span>
        <p class="mt-3 text-sm font-medium text-gray-500">
          Passenger localization not found for the selected language.
        </p>
      </div>
      <div class="flex flex-wrap -mx-2" v-else>
        <label
          class="block w-full px-2 my-2 sm:w-1/2 xl:w-1/3"
          v-for="(value, key) of localizations"
          :key="key"
        >
          <span class="block mb-1 text-xs font-semibold tracking-wider text-gray-500 uppercase">{{ key }}</span>
          <input
            v-model="localizations[key]"
            class="block w-full h-10 px-3 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
          />
        </label>
      </div>
    </div>
    <div
      v-if="!notFound"
      class="sticky bottom-0 flex justify-end px-6 py-4 bg-white border-t border-gray-100"
    >
      <button
        class="inline-flex items-center justify-center h-10 px-8 text-sm font-semibold text-white rounded-xl shadow-sm transition-colors duration-150"
        :disabled="busy"
        :class="
          busy
            ? 'bg-taxiye-300 cursor-not-allowed'
            : 'bg-taxiye-500 hover:bg-taxiye-600'
        "
      >
        <span v-if="busy" class="mr-2 text-base material-icons-round spin">sync</span>
        {{ busy ? 'Saving…' : 'Update' }}
      </button>
    </div>
  </form>
</template>

<script>

export default {
  props: {
localization: Object
  },
  data() {
    return {
      localizations: {},
      busy: false,
      newIncentive: {
        rate: 0,
        every: 0,
      },
      newVoucherType: {
        amount: 0,
        id: 0,
      },
      notFound: false,
      error: null
    };
  },
  watch: {
    localization: {
      deep: true,
      handler() {
        this.fetchLocalizations();
      }
    }
  },
  created() {
    this.fetchLocalizations();
  },
  computed: {
    addIncentiveDisabled() {
      return [
        !this.newIncentive.rate,
        !this.newIncentive.every,
        isNaN(this.newIncentive.rate),
        isNaN(this.newIncentive.every),
        this.newIncentive.rate > 100,
        this.newIncentive.rate <= 0,
        this.newIncentive.every != parseInt(this.newIncentive.every),
        this.newIncentive.every < 1,
      ].some((x) => x);
    },
    addVoucherTypeDisabled() {
      return [
        !this.newVoucherType.amount,
        !this.newVoucherType.id,
        isNaN(this.newVoucherType.amount),
        this.newVoucherType.amount < 0,
        parseInt(this.newVoucherType.amount) != Number(this.newVoucherType.amount),
      ].some(x => x)
    }
  },
  methods: {
    fetchLocalizations() {
      this.notFound = false;
      this.error = null;
      this.$misc
        .get(`/passenger-localizations/${this.localization.name}`)
        .then((response) => {
          this.localizations = response.data.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == "404") {
            this.notFound = true;
          }
          this.error = err;
        });
    },
    update() {
      this.busy = true;
      this.$misc
        .patch(`/passenger-localizations/${this.localization.name}`, { ...this.localizations })
        .then(() => {
          window.flash({ type: "success", body: "Updated Successfully!" });
        })
        .catch((err) => {
          window.flash({ type: "error", body: "Failed to save localizations!" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
